import { ThemeUICSSObject } from '@apia/theme';

export const attachmentPreview: ThemeUICSSObject = {
  '&.attachmentPreview': {
    alignItems: 'stretch',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    minHeight: 0,
    minWidth: 0,
    overflow: 'hidden',
    width: '100%',
  },

  '&.attachmentPreview--image': {
    background: 'palette.background.default',
  },

  '.attachmentPreview__imageViewport': {
    alignItems: 'center',
    cursor: 'grab',
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'center',
    minHeight: 0,
    minWidth: 0,
    overflow: 'hidden',
    touchAction: 'none',
    userSelect: 'none',

    '&:active': {
      cursor: 'grabbing',
    },
  },

  '.attachmentPreview__image': {
    display: 'block',
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
    transformOrigin: 'center center',
    userSelect: 'none',
    willChange: 'transform',
  },

  '.attachmentPreview__pdf': {
    border: 'none',
    flex: '1 1 auto',
    height: '100%',
    minHeight: 0,
    minWidth: 0,
    width: '100%',
  },

  '.attachmentPreview__audio': {
    alignItems: 'center',
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'center',
    minHeight: '160px',
    minWidth: 0,
    p: 4,
    width: '100%',

    audio: {
      width: 'min(100%, 520px)',
    },
  },
};
